import plusTwo from '../assets/plusTwo.svg';
import skip from '../assets/skip.svg';
import reverse from '../assets/reverse.svg';
import cornerPlusTwo from '../assets/cornerPlusTwo.svg';
import cornerPlusFour from '../assets/cornerPlusFour.svg';
import colors from '../assets/colors.svg';
import zero from '../assets/zero.svg';
import one from '../assets/one.svg';
import two from '../assets/two.svg';
import three from '../assets/three.svg';
import four from '../assets/four.svg';
import five from '../assets/five.svg';
import six from '../assets/six.svg';
import seven from '../assets/seven.svg';
import eight from '../assets/eight.svg';
import nine from '../assets/nine.svg';
import colorsBlue from '../assets/colors_blue.svg';
import colorsRed from '../assets/colors_red.svg';
import colorsYellow from '../assets/colors_yellow.svg';
import colorsGreen from '../assets/colors_green.svg';
import rainbow from '../assets/rainbow.svg';
import blind from '../assets/blind.svg'

function Card({ card, active=true }) {
    let cardClass;
    switch (card.color) {
        case 'green':
            cardClass = 'bg-green-500'
            break;
        case 'yellow':
            cardClass = 'bg-yellow-500'
            break;
        case 'blue':
            cardClass = 'bg-blue-500'
            break;
        case 'red':
            cardClass = 'bg-red-500'
            break;
        case 'wild':
            cardClass = 'bg-gray-800'
            break;
        case 'rainbow':
            cardClass = 'bg-rainbow'
            break;
        default:
            // cardClass = ''
            break;
    }
    switch (card.content) {
        case 'colorChange_colorPicked':
            cardClass = 'bg-gray-800'
            break;
        case 'plusFour_colorPicked':
            cardClass = 'bg-gray-800'
            break;
        case 'rainbow':
            cardClass = 'bg-gray-800'
            break;
        default:
            // cardClass = ''
            break;
    }
    cardClass += ' w-32 h-48 border-4 rounded-lg ';
    cardClass += active ? ' ' : 'grayscale-[65%] ';

    let borderColor = 'white';
    let contentSrc = null;
    let cornerSrc = null;
    let contentClass = null;
    let cornerClass = null;
    switch (card.content) {
        case 'colorChange_colorPicked':
            cornerSrc = colors;
            contentClass = 'p-1.5';
            cornerClass = 'p-0.5';
            switch (card.color) {
                case 'red':
                    contentSrc = colorsRed;
                    break;
                case 'yellow':
                    contentSrc = colorsYellow;
                    break;
                case 'green':
                    contentSrc = colorsGreen;
                    break;
                case 'blue':
                    contentSrc = colorsBlue;
                    break;
                default:
                    contentSrc = colorsBlue;
                    break;
            }
            break;
        case 'plusFour_colorPicked':
            cornerSrc = colors;
            contentClass = 'p-1.5';
            cornerClass = 'p-0.5';
            switch (card.color) {
                case 'red':
                    contentSrc = colorsRed;
                    break;
                case 'yellow':
                    contentSrc = colorsYellow;
                    break;
                case 'green':
                    contentSrc = colorsGreen;
                    break;
                case 'blue':
                    contentSrc = colorsBlue;
                    break;
                default:
                    contentSrc = colorsBlue;
                    break;
            }
            break;
        case 'plusFour':
            contentSrc = colors;
            cornerSrc = cornerPlusFour;
            contentClass = 'p-1.5';
            break;
        case 'plusTwo':
            contentSrc = plusTwo;
            cornerSrc = cornerPlusTwo;
            contentClass = 'p-1';
            break;
        case 'skip':
            contentSrc = skip;
            cornerSrc = skip;
            contentClass = 'p-1';
            break;
        case 'reverse':
            contentSrc = reverse;
            cornerSrc = reverse;
            contentClass = 'p-1.5';
            cornerClass = 'p-0.5';
            break;
        case '0':
            contentSrc = zero;
            cornerSrc = zero;
            cornerClass = '-translate-x-0.5';
            break;
        case '1':
            contentSrc = one;
            cornerSrc = one;
            cornerClass = '-translate-x-0.5';
            break;
        case '2':
            contentSrc = two;
            cornerSrc = two;
            cornerClass = '-translate-x-0.5';
            break;
        case '3':
            contentSrc = three;
            cornerSrc = three;
            cornerClass = '-translate-x-0.5';
            break;
        case '4':
            contentSrc = four;
            cornerSrc = four;
            cornerClass = '-translate-x-0.5';
            break;
        case '5':
            contentSrc = five;
            cornerSrc = five;
            cornerClass = '-translate-x-0.5';
            break;
        case '6':
            contentSrc = six;
            cornerSrc = six;
            cornerClass = '-translate-x-0.5';
            break;
        case '7':
            contentSrc = seven;
            cornerSrc = seven;
            cornerClass = '-translate-x-0.5';
            break;
        case '8':
            contentSrc = eight;
            cornerSrc = eight;
            cornerClass = '-translate-x-0.5';
            break;
        case '9':
            contentSrc = nine;
            cornerSrc = nine;
            cornerClass = '-translate-x-0.5';
            break;
        case 'rainbow':
            contentSrc = rainbow;
            cornerSrc = rainbow;
            cornerClass = 'px-0.5';
            switch (card.color) {
                case 'red':
                    borderColor = '#ef4444'
                    break;
                case 'yellow':
                    borderColor = '#eab308'
                    break;
                case 'green':
                    borderColor = '#84cc16'
                    break;
                case 'blue':
                    borderColor = '#3b82f6'
                    break;
                default:
                    break;
            }
            break;
        case 'flash':
            contentSrc = blind;
            cornerSrc = blind;
            contentClass = 'p-0.5';
            break;
        default: // the default wild card
            contentSrc = colors;
            cornerSrc = colors;
            contentClass = 'p-1.5';
            cornerClass = 'p-0.5';
            break;
    }

    return (
        <div style={{ borderColor: borderColor }} className={cardClass + ' relative flex justify-center items-center group-hover/pt:-translate-y-4 group-hover:-translate-y-10 transition ease-out pointer-events-none'}>
            {/* <div className='absolute top-6'>{card.content} {card.color}</div> */}
            <div className="absolute w-6 top-1.5 left-1">
                <img src={cornerSrc} className={cornerClass} alt={card.color + card.content}></img>
            </div>
            <div className='p-4'>
                <img src={contentSrc} className={contentClass} alt={card.color + card.content} ></img>
            </div>
            <div className="absolute w-6 bottom-1.5 right-1 rotate-180">
                <img src={cornerSrc} className={cornerClass} alt={card.color + card.content}></img>
            </div>
        </div>
    );
}

export default Card;